import classnames from 'classnames'
import { FC, FormEvent } from 'react'
import { UnmountClosed } from 'react-collapse'

import { Button, Link, Typography, Grid } from '~ui'
import Template from '../common/template'
import CurrencyInput from '../common/currency-input'
import { WHAT_IS_MAX_BIDDING } from '../../../routes/external'
import { formatCurrency } from '../../../utils'

import styles from './place-bid.module.scss'

interface PlaceBidComponent {
  userMaxBidAmount: number
  userHasMaxBid: boolean
  isHighestBidder: boolean
  placeholder: string
  error: string
  bid: number
  onSubmit: (e: FormEvent<HTMLFormElement>) => void
  setBid: (bid: number) => void
}

const PlaceBidComponent: FC<PlaceBidComponent> = ({
  userMaxBidAmount,
  userHasMaxBid,
  isHighestBidder,
  placeholder,
  error,
  bid,
  onSubmit,
  setBid,
}) =>
  isHighestBidder ? (
    <Template classNames={classnames(styles.wrapper)}>
      <div className={styles.content}>
        <div className={styles['high-bid']}>
          <Grid alignItems="center" gridAutoFlow="row">
            <Typography.Text bold>You are the highest bidder.</Typography.Text>
            {userHasMaxBid && (
              <Typography.Text size="sm">
                Your maximum bid is set to{' '}
                <Typography.Text bold size="sm">
                  {formatCurrency(userMaxBidAmount, 0)}
                </Typography.Text>
              </Typography.Text>
            )}
          </Grid>
        </div>
      </div>
    </Template>
  ) : (
    <Template classNames={classnames(styles.wrapper)} title="Place bid" iconName="checked">
      <div className={styles.content}>
        <form className={styles.form} onSubmit={onSubmit}>
          <CurrencyInput
            placeholder={placeholder}
            errorMessage={error}
            value={bid}
            updateValue={setBid}
          />
          <Button type="submit" variant="primary">
            Place Bid
          </Button>
        </form>
        <UnmountClosed isOpened={!!error}>
          <Typography.Text size="sm" color="red">
            {error}
          </Typography.Text>
        </UnmountClosed>
        <Typography.Text size="sm" color="light-gray">
          Enter the maximum amount you are willing to pay. Learn about{' '}
          <Link color="green" href={WHAT_IS_MAX_BIDDING} target="_blank" rel="noopener noreferrer">
            Max Bidding.
          </Link>
        </Typography.Text>
      </div>
    </Template>
  )

export default PlaceBidComponent
